import { resetBgWithoutCvMaskBySf } from '../SizeFaces/fs.js';
import { UtilF } from '../../../Util/F/Function/module/UtilF.js';
import { getCvObj } from '../Fcanvas/cv_object.js';
import { ConfigSentryF } from '@modules/Config/Sentry/F/Function/module/ConfigSentryF.js';

export async function makeCvDescriptionInMakerA(canvas, bpf, sf) {
  try {
    const last_cv_bpcf = getCvObj(canvas._objects, 'cv_description');
    if (last_cv_bpcf) canvas.remove(last_cv_bpcf);
    const description_url = bpf['description_url' + G._en];

    if (!description_url) return;
    await new Promise(function (resolve) {
      const toUrl = UtilF.isLegacyMobile() ? G.to_900 : G.mp.maker.url;
      fabric.Image.fromURL(toUrl(G.mp.maker.url(description_url)), function (img) {
        img.set({
          selectable: false,
          evented: false,
          globalCompositeOperation: 'source-over',
          _data: { cv_type: 'cv_description', is_not_design: true },
        });
        resetBgWithoutCvMaskBySf(img, sf);
        canvas.add(img);
        canvas.renderAll();
        resolve();
      });
    });
  } catch (e) {
    ConfigSentryF.criticalError(e, { tags: { module: 'makeCvDescriptionInMakerA' } });
  }
}
